import ApplicationAdapter from "./application";

export default class NetworkAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/network/create?projectkey=${snapshot.belongsTo("project").id}`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    return `${this.apiBaseUri}/network/delete?projectkey=${snapshot.belongsTo("project").id}&networkid=${id}`;
  }
}
